import React, { useState } from 'react';
import { FaStarOfLife } from 'react-icons/fa';
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa6';
import { Form, Button } from 'react-bootstrap';
import './Settings.css';
import UpdatePasswordLogic from './UpdatePasswordLogic';


function UpdatePassword() {

    const {
        isLoading,
        showOldPassword,
        setShowOldPassword,
        showNewPassword,
        setShowNewPassword,
        showConfirmPassword,
        setShowConfirmPassword,
        handleCancel,
        handleSubmit,
        errorMessages,
        hud,setOldPassword,
        oldPassword,
        newPassword,setNewPassword,
        confirmPassword,setConfirmPassword
    } = UpdatePasswordLogic();
    return (
        <div className="card1 mx-auto">
            <div className="card1-header text-right rounded">
                <h1 style={{ fontWeight: 500, fontSize: '18px' }}>Password Settings</h1>
                <span>Change or reset your account password</span>
            </div>
            <hr />
            <div className="card1-body">
                <div className="row justify-content-center">
                    <div className="col-xl-12 col-lg-16 col-xs-24">
                        {isLoading ? (
                            <div style={{ textAlign: 'center', color: 'black', height: '600px', paddingTop: '300px', }}>
                                <>{hud('Please Wait...')}</>
                            </div>
                        ) : (
                            <Form onSubmit={handleSubmit} className="mx-auto d-block w-100">
                                <Form.Group controlId="formOldPassword" className="mx-auto w-50 text-left">
                                    {/* Old Password */}
                                    <Form.Label className="d-block bold-label">
                                        <FaStarOfLife className="text-dangers" style={{ width: '8px' }} /> Old Password:
                                    </Form.Label>
                                    <div className="password-input-container">
                                        <Form.Control
                                            type={showOldPassword ? 'text' : 'password'}
                                            onChange={(e) => setOldPassword(e.target.value)}
                                            value={oldPassword}
                                            className="text-black mb-3 input-form"
                                        />
                                        <span
                                            className="toggle-password-icon"
                                            onClick={() => setShowOldPassword(!showOldPassword)}
                                        >
                                            {showOldPassword ? <FaRegEye className='pass-eye-1' /> : <FaRegEyeSlash />}
                                        </span>
                                    </div>
                                    {errorMessages.oldPassword && <div className="text-dangers">{errorMessages.oldPassword}</div>}

                                    {/* New Password */}
                                    <Form.Label className="d-block bold-label">
                                        <FaStarOfLife className="text-dangers" style={{ width: '8px' }} /> New Password:
                                    </Form.Label>
                                    <div className="password-input-container">
                                        <Form.Control
                                            type={showNewPassword ? 'text' : 'password'}
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            className="text-black mb-3 input-form"
                                        />
                                        <span
                                            className="toggle-password-icon"
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                        >
                                            {showNewPassword ? <FaRegEye className='pass-eye-1' /> : <FaRegEyeSlash />}
                                        </span>
                                    </div>
                                    {errorMessages.newPassword && <div className="text-dangers">{errorMessages.newPassword}</div>}

                                    {/* Confirm Password */}
                                    <Form.Label className="d-block bold-label">
                                        <FaStarOfLife className="text-dangers" style={{ width: '8px' }} /> Confirm Password:
                                    </Form.Label>
                                    <div className="password-input-container">
                                        <Form.Control
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            className="text-black mb-3 input-form"
                                        />
                                        <span
                                            className="toggle-password-icon"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        >
                                            {showConfirmPassword ? <FaRegEye className='pass-eye-1' /> : <FaRegEyeSlash />}
                                        </span>
                                    </div>
                                    {errorMessages.confirmPassword && <div className="text-dangers">{errorMessages.confirmPassword}</div>}

                                    <div className="d-flex mt-4">
                                        <Button type="submit" className="btn1 border-0">
                                            Change Password
                                        </Button>
                                        <Button
                                            type="button"
                                            className="btn-cancel border-0 mx-4"
                                            style={{ backgroundColor: 'gray', color: 'white' }}
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </Form.Group>
                            </Form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdatePassword;